// URL BASE
//export const base_url = 'http://localhost:3307/api';

//export const base_url = 'https://apicoresys.ebtapps.com/api';
export const base_url = 'https://apiunidqr.ebtapps.com/api';
//export const base_url = 'https://apicoresys.elitebordergroup.com/api';